import { Injector } from '@angular/core';
import { FontAwesomeService } from '../services/font-awesome.service';

/**
 * Returns a function that initializes the icons in the application.
 * @param injector - The injector used to get icon services and dependencies.
 * @returns A function that initializes the icons in the application.
 */
export function IconLoader(injector: Injector): () => void {
  return () => injector.get(FontAwesomeService).initIcons();
}
